module.exports = __webpack_public_path__ + "img/202408_02.3e8499e4.jpg";